var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { styled } from 'styled-components';
import { TaskTarget } from '@hn-ui/icons';
var StyledProgressBar = styled.div.withConfig({ displayName: "StyledProgressBar", componentId: "sc-mogvy7" })(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  height: 8px;\n  box-sizing: border-box;\n  background: #fff;\n  border: 1px solid\n    ", ";\n  border-radius: 10px;\n  margin-left: 4px;\n\n  &:after {\n    content: '';\n    width: ", ";\n    height: 100%;\n    background: ", ";\n    display: block;\n    border-radius: ", ";\n  }\n"], ["\n  height: 8px;\n  box-sizing: border-box;\n  background: #fff;\n  border: 1px solid\n    ", ";\n  border-radius: 10px;\n  margin-left: 4px;\n\n  &:after {\n    content: '';\n    width: ", ";\n    height: 100%;\n    background: ", ";\n    display: block;\n    border-radius: ", ";\n  }\n"])), function (_a) {
    var $isTargetCompleted = _a.$isTargetCompleted;
    return ($isTargetCompleted ? '#6BAE46' : '#FFC500');
}, function (_a) {
    var $percentage = _a.$percentage;
    return $percentage + "%";
}, function (_a) {
    var $isTargetCompleted = _a.$isTargetCompleted;
    return $isTargetCompleted ? '#6BAE46' : '#FFC500';
}, function (_a) {
    var $percentage = _a.$percentage;
    return $percentage < 95 ? '10px 0 0 10px' : '10px';
});
var Container = styled.div.withConfig({ displayName: "Container", componentId: "sc-16dbhcg" })(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  display: flex;\n  align-items: center;\n  height: 24px;\n"], ["\n  display: flex;\n  align-items: center;\n  height: 24px;\n"])));
var ProgressBar = function (_a) {
    var _b = _a.width, width = _b === void 0 ? 41 : _b, _c = _a.percentage, percentage = _c === void 0 ? 80 : _c, _d = _a.isTargetCompleted, isTargetCompleted = _d === void 0 ? true : _d, rest = __rest(_a, ["width", "percentage", "isTargetCompleted"]);
    return (_jsxs(Container, __assign({}, rest, { children: [_jsx(TaskTarget, { size: 20, color: 'purple30' }, void 0), _jsx(StyledProgressBar, { "$percentage": percentage, "$isTargetCompleted": isTargetCompleted, style: { width: width } }, void 0)] }), void 0));
};
export { ProgressBar };
var templateObject_1, templateObject_2;
